import { API_URL } from '../../config.js';
import { toApiError } from '../../lib/api-error';

type SlackTestResponse = { ok: boolean; error?: string };

export async function sendSlackTestMessage(): Promise<SlackTestResponse> {
  const res = await fetch(`${API_URL}/integrations/slack/test`, {
    method: 'POST',
    credentials: 'include',
  });
  if (!res.ok) throw await toApiError(res, 'Failed to send test message');
  return res.json() as Promise<SlackTestResponse>;
}
